import {obvioUrl} from 'lib/url'
import {Widget} from 'Event/Widget/template'

export type WidgetType = 'redirect' | 'button' | 'calendar'

export default function generateWidgetCode(
  type: WidgetType,
  widget: Widget,
): string {
  const url = `${obvioUrl('/widget/obvio_widget.js')}?t=${type}&at=${
    widget.token
  }`

  return `<!-- Obv.io Widget Code -->
<div id="obvio-widget"></div>
<script
src="${url}"
async>
</script>
<!-- Obv.io Widget Code End -->`
}
